import React from "react";
import { brand } from "../../content/siteContent";

const words = [
  "Transform.", "Apply.", "Qualify.", "Diagnose.", "Deliver.",
  "Leader Standard Work", "Transformation Office", "Applied Evidence",
];

/* One slow editorial marquee. Pauses under prefers-reduced-motion via CSS. */
export const Marquee = () => (
  <section
    data-testid="marquee"
    className="bg-navy border-y border-hair-dark overflow-hidden py-6 select-none"
    aria-hidden="true"
  >
    <div className="flex gap-10 whitespace-nowrap animate-[marquee_38s_linear_infinite] motion-reduce:animate-none">
      {[...words, ...words, ...words].map((w, i) => (
        <span
          key={i}
          className={`font-display font-extrabold tracking-tight text-2xl lg:text-3xl ${
            w === brand.tagline.split(" ")[0] || ["Transform.", "Apply.", "Qualify."].includes(w)
              ? "text-white"
              : "text-white/25"
          }`}
        >
          {w}
          <span className="text-teal ml-10">/</span>
        </span>
      ))}
    </div>
    <style>{`@keyframes marquee { from { transform: translateX(0);} to { transform: translateX(-33.33%);} }`}</style>
  </section>
);
